export class CountedHash
{
  n: number;
  val: any;

  constructor()
    {
      this.n = 0;
      this.val = {};
    }

  get length(): number { return this.n; }

  test(id: string): boolean
    {
      return id != '' && this.val[id] !== undefined;
    }

  set(id: string): void
    {
      if (id != '' && ! this.test(id))
      {
        this.n++;
        this.val[id] = true;
      }
    }

  clear(id: string): void
    {
      if (this.test(id))
      {
        this.n--;
        delete this.val[id];
      }
    }

  empty(): void
    {
      this.n = 0;
      this.val = {};
    }

  asArray(): string[]
    {
      let a: string[] = [];

      this.forEach(id => { a.push(id) });

      return a;
    }

  asString(): string
    {
      for (var id in this.val) if (this.val.hasOwnProperty(id))
        return id;

      return '';
    }

  forEach(f: (id: string) => void): void
    {
      for (var id in this.val) if (this.val.hasOwnProperty(id))
        f(id);
    }
}
